class ContactForm {
  constructor() {
    const root = document.querySelector('.contact-form');

    if (root) {
      const views = root.querySelectorAll('.contact-form__view');
      const files = root.querySelectorAll('.contact-form__file');
      const radios = root.querySelectorAll('.contact-form__radio');

      views.forEach(view => {
        const prev = view.querySelector('.contact-form__button--prev');
        const next = view.querySelector('.contact-form__button--next');

        prev?.addEventListener('click', () => this.prevView(view));
        next?.addEventListener('click', () => this.nextView(view));
      });

      files.forEach(field => {
        const input = field.querySelector('input');
        const label = field.querySelector('span');

        input.name = 'multifile[]';
        input.setAttribute('multiple', true);

        input.addEventListener('change', () => {
          [...input.files].map(file => {
            const element = document.createElement('div');

            element.innerHTML = file.name;

            label.appendChild(element);
          });
        });
      });

      radios.forEach(field => {
        const subject = field.querySelector('input[name="subject"]');
        const recipient = field.querySelector('input[name="recipient"]');

        subject.addEventListener('change', () => {
          recipient.checked = subject.checked;
        });

        recipient.addEventListener('change', () => {
          subject.checked = recipient.checked;
        });
      });
    }
  }

  prevView(el) {
    const views = document.querySelectorAll('.contact-form__view');

    views.forEach(item => {
      if (el.previousElementSibling == item) {
        item.classList.add('active');
      }
      else {
        item.classList.remove('active');
      }
    });
  }

  nextView(el) {
    const views = document.querySelectorAll('.contact-form__view');

    views.forEach(item => {
      if (el.nextElementSibling == item) {
        item.classList.add('active');
      }
      else {
        item.classList.remove('active');
      }
    });
  }
}

export default ContactForm;
